import { render } from "./ClassList.vue?vue&type=template&id=2de6f9c8"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"

import "./ClassList.vue?vue&type=style&index=0&id=2de6f9c8&lang=scss"
script.render = render

export default script